<template>
  <v-dialog v-model="open" :max-width="430" persistent>
    <v-card class="reg-dialog">
      <v-card-title class="text-h5">
        <v-row justify="end">
          <v-btn icon
                 @click="onClose">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row align="center" class="flex-column">
          <v-icon class="my-3 text-h3" color="orange">
            mdi-lock
          </v-icon>
          <template v-if="!twoFaEnabled">
            <p class="text-h6 text-center">
              Configurar autenticação em duas etapas
            </p>
            <p class="mt-2">
              Utilize um aplicativo de autenticação como Google Authenticator para escanear o QR Code abaixo:
            </p>
            <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="QR Code">
          </template>
          <template v-else>
            <p class="text-h6 text-center">
              Autenticação Adicional Obrigatória
            </p>
          </template>
          <p class="mt-2">
            Digite o token gerado pelo aplicativo de autenticação:
          </p>
          <v-col cols="12">
            <div>
              <otp-input ref="otpInput"
                         input-classes="otp-input"
                         separator="-"
                         :num-inputs="6"
                         :should-auto-focus="true"
                         :is-input-num="true"
                         input-type="tel"
                         @on-complete="onInputToken" />
            </div>
          </v-col>
          <v-alert outlined
                   type="error"
                   transition="scale-transition"
                   class="mt-4 py-2"
                   :value="tokenError">
            Token inválido, tente novamente
          </v-alert>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn ref="detaultButton"
               v-shortkey="['enter']"
               block
               large
               color="orange"
               class="reg-btn-lower subtitle my-3 white--text"
               :loading="isLoading"
               @shortkey="onConfirm()"
               @click.stop="onConfirm()">
          {{ 'Validar Token' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OtpInput from '@bachdgvn/vue-otp-input'
import RestApi from '~services/restApi'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    'otp-input': OtpInput
  },
  data() {
    return {
      open: false,
      token: '',
      qrCodeUrl: '',
      isLoading: false,
      tokenError: false
    }
  },
  computed: {
    ...mapState({
      me: state => state.authModule.me
    }),
    twoFaEnabled() {
      return this.me.twoFaEnabled
    }
  },
  mounted() {
    if (!this.twoFaEnabled) {
      this.onSetup2Fa()
    }
  },
  methods: {
    ...mapActions(['getMe']),
    async onSetup2Fa() {
      const res = await RestApi.setup2Fa()
        .catch(() => {
          this.$toasted.error('Erro ao configurar autenticação em duas etapas, contacte o suporte')
        })
      this.qrCodeUrl = res.data.qrCodeUrl
    },
    onInputToken(token) {
      this.token = token
    },
    onConfirm() {
      this.isLoading = true
      this.tokenError = false
      RestApi.verify2Fa(this.token).then((res) => {
        if (res.data.valid) {
          if (!this.twoFaEnabled) {
            this.getMe()
          }
          this.open = false
          this.$emit('confirm')
        }
      }).catch(() => {
        this.tokenError = true
      }).finally(() => {
        this.isLoading = false
      })
    },
    onCancel() {
      this.open = false
      this.$emit('cancel')
    },
    onClose() {
      this.open = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 10px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
